module.exports = __webpack_public_path__ + "fonts/7ce6760.ttf";